<template>
  <div class="appointment_cancel">
     <el-divider content-position="left">预约注销列表</el-divider>
    <el-collapse v-model="activeNames">
  <el-collapse-item name="1">
    <template slot="title">
      <i style="color:blue">搜索</i>
    </template>
    <div>
    <el-select v-model="city" placeholder="城市" @click.native="getcities()" size="small">
    <el-option
      v-for="item in cities"
      :key="item.id"
      :label="item.label"
      :value="item.Provincial">
    </el-option>
  </el-select>
    <el-select v-model="company_type" placeholder="公司类型" size="small">
    <el-option
      v-for="item in company_types"
      :key="item"
      :label="item.label"
      :value="item">
    </el-option>
  </el-select>
    <el-select v-model="cancel_type" placeholder="注销类型" size="small">
    <el-option
      v-for="item in cancel_types"
      :key="item"
      :label="item.label"
      :value="item">
    </el-option>
  </el-select>
    <el-input v-model="form.phone" placeholder="电话" size="small"></el-input>
  </div>
    <div class="s-wamp">
        <el-button-group>
            <el-button type="" size="mini" @click="clearinput">重&nbsp;&nbsp;&nbsp;&nbsp;置</el-button>
            <el-button type="primary" size="mini" class="appo-search" @click="inputsearch">开始搜索</el-button>
        </el-button-group>
    </div>
  </el-collapse-item>
  </el-collapse>
    <el-table
    :data="tableData"
    border
    style="width: 100%">
    <el-table-column
      prop="id"
      label="序号"
      width="50">
    </el-table-column>
    <el-table-column
      prop="city"
      label="城市"
      width="100">
    </el-table-column>
    <el-table-column
      prop="company_type"
      label="公司类型"
      width="100">
    </el-table-column>
    <el-table-column
      prop="company_info"
      label="基本信息"
      width="180">
    </el-table-column>
    <el-table-column
      prop="cancel_type"
      label="注销类型"
      width="80">
    </el-table-column>
    <el-table-column
      prop="phone"
      label="电话"
      width="130">
    </el-table-column>
    <el-table-column
      prop=""
      label="操作"
      width="180">
    </el-table-column>
  </el-table>
  <el-pagination
  background
  layout="prev, pager, next"
  :total="1000" style="text-align: right">
</el-pagination>
  </div>
</template>

<script>
export default {
  name: 'AppointmentCancel',
  data () {
    return {
      activeNames: '',
      city: '',
      cities: [],
      company_type: '',
      company_types: ['个体工商户', '个人独资', '有限责任公司 （有限公司）', '股份有限公司'],
      cancel_type: '',
      cancel_types: ['注销', '吊销转注销'],
      form: {
        phone: ''
      },
      tableData: []
    }
  },
  created () {
    return this.getcities()
  },
  methods: {
    getcities () {
      this.$axios.get('/api/appo_cancel/getcity').then((res) => {
        const { data } = res
        if (data.code === 1) {
          this.cities = data.data
        }
      }).catch(() => {
        this.$message.error('获取数据失败')
      })
    },
    clearinput () {
      this.city = ''
      this.company_type = ''
      this.cancel_type = ''
      this.phone = ''
    },
    inputsearch () {
      var Provincial = this.city
      var comT = this.company_type
      var cancelT = this.cancel_type
      var pho = this.phone
      this.$axios.get('/api/appo_cancel/cancelinfo', [Provincial, comT, cancelT, pho]).then((res) => {
        console.log(res)
      })
    }
  }
}
</script>

<style scoped>
.appointment_cancel{
    /* margin-left: 3.6rem; */
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
.appointment_cancel .el-collapse{
    border-top: none;
}
.appointment_cancel .el-collapse-item__header {
    color: #4c87fc;
    font-weight: bold;
    padding-left: 1%;
}
.el-select .el-input__inner:focus {
    border-color: #cccccc;
}
.appointment_cancel .el-input__inner{
    border-color: #cccccc;
    width: 3rem;
    margin-top: 3px;
}
.el-input.is-active .el-input__inner, .el-input__inner:focus {
    border-color: #cccccc;
    outline: 0;
}
.s-wamp{
    text-align: center;
    padding-top: 6px;
}
.el-button-group .el-button--primary:last-child {
    margin-left: 5px;
}
.el-input--small {
    width: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/appointment_cancel/AppointmentCancel.vue